import { render, staticRenderFns } from "./SurveyPageEditable.vue?vue&type=template&id=271c6996&scoped=true&"
import script from "./SurveyPageEditable.vue?vue&type=script&lang=js&"
export * from "./SurveyPageEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c6996",
  null
  
)

export default component.exports